module.exports = __webpack_public_path__ + "img/doc-instruction-icon.6a88cb40.svg";